import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Linkedin, Phone, Mail, MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { useServices } from "../context/ServicesContext";
import { LOCALITIES } from "../data/services";
import { CONTACT, whatsappLink } from "../data/content";

export default function Footer() {
  const { services } = useServices();
  return (
    <footer className="bg-navy text-slate-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <Logo light />
          <p className="mt-4 text-sm text-slate-400 max-w-xs">Har Local Problem Ka Solution. Trusted local professionals for every home & local service need.</p>
          <div className="flex items-center gap-3 mt-5">
            {[
              { Icon: Instagram, label: "instagram" },
              { Icon: Facebook, label: "facebook" },
              { Icon: Youtube, label: "youtube" },
              { Icon: Linkedin, label: "linkedin" },
            ].map(({ Icon, label }) => (
              <a key={label} href="#" data-testid={`footer-social-${label}`} aria-label={label}
                 className="grid place-items-center w-9 h-9 rounded-lg bg-white/10 hover:bg-brand-orange transition-colors">
                <Icon className="w-4 h-4 text-white" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-3 text-sm">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-brand-orange">About</Link></li>
            <li><Link to="/#services" className="hover:text-brand-orange">Services</Link></li>
            <li><Link to="/#how-it-works" className="hover:text-brand-orange">How It Works</Link></li>
            <li><Link to="/track" className="hover:text-brand-orange">Track Booking</Link></li>
            <li><Link to="/partner-register" className="hover:text-brand-orange">Partner With Us</Link></li>
            <li><Link to="/contact" className="hover:text-brand-orange">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-3 text-sm">Top Services</h4>
          <ul className="space-y-2 text-sm">
            {services.slice(0, 5).map((s) => (
              <li key={s.id}><Link to={`/services/${s.slug}`} className="hover:text-brand-orange">{s.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-3 text-sm">Legal & Contact</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy" className="hover:text-brand-orange">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-brand-orange">Terms & Conditions</Link></li>
            <li><Link to="/cancellation" className="hover:text-brand-orange">Cancellation Policy</Link></li>
          </ul>
          <div className="mt-4 space-y-2 text-sm">
            <a href={CONTACT.phoneHref} className="flex items-center gap-2 hover:text-brand-orange"><Phone className="w-4 h-4" /> {CONTACT.phone}</a>
            <a href={whatsappLink()} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-orange"><MessageCircle className="w-4 h-4" /> WhatsApp</a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-brand-orange"><Mail className="w-4 h-4" /> {CONTACT.email}</a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-400">
          <p>© {new Date().getFullYear()} ApnaFix. All rights reserved.</p>
          <p className="flex flex-wrap gap-x-3 gap-y-1">
            {LOCALITIES.map((l) => (
              <Link key={l.id} to={`/locations/${l.slug}`} className="hover:text-brand-orange">{l.name}</Link>
            ))}
          </p>
        </div>
      </div>
    </footer>
  );
}
